/**
 * Taf请求上下文类型定义
 */
export interface ITafContext {
  /** 请求参数 */
  request: {
    /** 服务端的ui, 如 accompanyui */
    moduleName: string;
    /** 接口名, 如 reactiveQuickOrderInvitation */
    funcName: string;
    ReqClass: any;
    RspClass: any;
    data: any;
    /** 超时时间，默认 6 秒 */
    timeoutMS?: number;
    /** 是否使用固定ua */
    useSendWupWithForceUa?: boolean;
    /** 请求开始时间 */
    startTime?: number;
  };
  /** 响应结果 */
  response: {
    /** 响应数据 */
    data?: any;
    /** 错误信息 */
    error?: any;
    /** 请求耗时(ms) */
    duration?: number;
  };
  /** 自定义属性，用于中间件间传递数据 */
  state: Record<string, any>;
}

/**
 * 中间件函数类型定义
 * @param ctx 上下文对象，包含请求和响应信息
 * @param next 调用下一个中间件的函数
 */
export type TafMiddleware = (ctx: ITafContext, next: () => Promise<void>) => Promise<void>;

/**
 * 中间件管理类，负责注册和执行中间件
 */
export class TafMiddlewareManager {
  private middlewares: TafMiddleware[] = [];

  /**
   * 注册中间件
   * @param middleware 中间件函数
   * @returns this 实例，支持链式调用
   */
  use(middleware: TafMiddleware): this {
    this.middlewares.push(middleware);
    return this;
  }

  /**
   * 执行中间件链
   * @param ctx 上下文对象
   * @returns Promise
   */
  compose(ctx: ITafContext): (fn?: () => Promise<any>) => Promise<void> {
    // 返回一个组合了所有中间件的函数
    return async (coreFunction?: () => Promise<any>) => {
      // 洋葱模型执行中间件
      const dispatch = async (index: number): Promise<void> => {
        // 如果已经执行完所有中间件，则执行核心函数（网络请求）
        if (index >= this.middlewares.length) {
          if (coreFunction) {
            const result = await coreFunction();
            ctx.response.data = result;
          }
          return;
        }

        const middleware = this.middlewares[index];
        await middleware(ctx, () => dispatch(index + 1));
      };

      await dispatch(0);
    };
  }
}

// 创建全局中间件管理器实例
export const tafMiddlewareManager = new TafMiddlewareManager();
